export default __webpack_public_path__ + "locales/pt/Payments.json?hash=6e38fa0c611e7bd7709cae2c3018833d";